import { BackOfficeCommentsTable } from "../../../../settlement/src/BackOfficeCommentsTable";
import { DataHeader, DataSource, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCashReceipt extends Layout {
    dataheaderCashReceipt: DataHeader;
    layoutBackOfficeCommentsTable: BackOfficeCommentsTable;
    panelCustomerBalance: Panel;
    sourceCashReceipt: DataSource;
    sourceCashReceiptDetail: DataSource;
    sourceComments: DataSource;
    tabAppliedItems: Tab;
    tabComments: Tab;
    tabGeneral: Tab;
    tableAppliedItems: Table;
    tabsetCashReceipt: Tabset;
    textboxAmountReceived: Textbox;
    textboxCustomerBalance: Textbox;
    textboxCustomerId: Textbox;
    textboxDeposit: Textbox;
    textboxPaymentMethod: Textbox;
    textboxRefNumber: Textbox;
    textboxUnappliedTotal: Textbox;
}
